<div class="star-rating">
  @for (diegoRating of diegoRatings; track diegoRating.name; let i = $index) {
    <div class="star-rating-item color-exemption" [ngClass]="{ checked: currentRating === i }" (click)="setRating(i)">
      @if (currentRating === i) {
        <mat-icon class="icon_checkmark" [svgIcon]="IconNames.ice_checkmark_circle" />
      }
      <mat-icon class="icon" [svgIcon]="diegoRating.icon" />
      <p>{{ diegoRating.name }}</p>
    </div>
  }
</div>
